export enum MenuLabel {
  ManageAgents = 'Manage Agents',
  Conversations = 'Conversations',
  KnowledgeManagement = 'Knowledge Management',
  CallManagement = 'Call Management',
  BatchCalls = 'Mass Outreach (Demo)',
  WidgetAnalytics = 'Widget Analytics',
  RoleManagement = 'Role Management',
  OrgManagement = 'Org Management',
  JSONManagement = 'JSON Management',
  ModelsManagement = 'Model Management',
  ConversationsBilling = 'Billing',
  PromptLibrary = 'Prompt Library',
  SipTrunk = 'SIP Trunk',
  SipTrunkVendors = 'SIP Trunk Vendors',
  Logout = 'Logout',
  Login = 'Login',
  Analytics = 'Analytics',
  LiveKitServer = 'LiveKit Server',
}

export const bottomMenuLabels: string[] = [
  MenuLabel.Logout,
  MenuLabel.JSONManagement,
  MenuLabel.RoleManagement,
  MenuLabel.OrgManagement,
  MenuLabel.ModelsManagement,
  MenuLabel.PromptLibrary,
  MenuLabel.SipTrunkVendors,
  MenuLabel.LiveKitServer,
];

export const ROUTE_SEGMENT = {
  AGENTS: 'agents',
  CONVERSATION: 'conversation',
  BILLING: 'billing',
  CONVERSATIONS: 'conversations',
  NEW: 'new',
} as const;

export const ROUTE_PARAM = {
  ORGANIZATION_ID: 'organization_id',
  AGENT_ID: 'agent_id',
  CONVERSATION_ID: 'conversation_id',
} as const;

export const ROUTE_QUERY_PARAM = {
  ORGANIZATION_ID: 'organization_id',
  USER_ID: 'user_id',
  USER_PHONE: 'user_phone',
  CONVERSATION_ID: 'conversation_id',
} as const;

export const ORG_ID_ROUTE_TOKEN = `:${ROUTE_PARAM.ORGANIZATION_ID}`;

export const ROUTE_PATH = {
  ANALYTICS: '/analytics',
  AGENTS: `/${ROUTE_SEGMENT.AGENTS}`,
  CONVERSATION: `/${ROUTE_SEGMENT.CONVERSATION}`,
  BILLING: `/${ROUTE_SEGMENT.BILLING}`,
  NOT_FOUND: '/404',
} as const;

export const CONVERSATION_EXTERNAL_ENTRY_PATHS = [
  ROUTE_PATH.CONVERSATION,
  `${ROUTE_PATH.CONVERSATION}/`,
] as const;

const routeParam = (name: string) => `:${name}`;

export const ROUTE_PATTERN = {
  agents: {
    list: `${ROUTE_PATH.AGENTS}/${routeParam(ROUTE_PARAM.ORGANIZATION_ID)}`,
    new: `${ROUTE_PATH.AGENTS}/${routeParam(ROUTE_PARAM.ORGANIZATION_ID)}/${ROUTE_SEGMENT.NEW}`,
    detail: `${ROUTE_PATH.AGENTS}/${routeParam(ROUTE_PARAM.ORGANIZATION_ID)}/${routeParam(ROUTE_PARAM.AGENT_ID)}`,
  },
  conversation: {
    list: `${ROUTE_PATH.CONVERSATION}/${routeParam(ROUTE_PARAM.ORGANIZATION_ID)}`,
    detail: `${ROUTE_PATH.CONVERSATION}/${routeParam(ROUTE_PARAM.ORGANIZATION_ID)}/${routeParam(ROUTE_PARAM.CONVERSATION_ID)}`,
  },
  billing: {
    list: `${ROUTE_PATH.BILLING}/${routeParam(ROUTE_PARAM.ORGANIZATION_ID)}`,
    agent: `${ROUTE_PATH.BILLING}/${routeParam(ROUTE_PARAM.ORGANIZATION_ID)}/${routeParam(ROUTE_PARAM.AGENT_ID)}`,
    conversationDetail: `${ROUTE_PATH.BILLING}/${routeParam(ROUTE_PARAM.ORGANIZATION_ID)}/${routeParam(ROUTE_PARAM.AGENT_ID)}/${ROUTE_SEGMENT.CONVERSATIONS}/${routeParam(ROUTE_PARAM.CONVERSATION_ID)}`,
  },
} as const;

export const ORG_SCOPED_ROUTE_PREFIXES = [
  ROUTE_SEGMENT.AGENTS,
  ROUTE_SEGMENT.CONVERSATION,
  ROUTE_SEGMENT.BILLING,
] as const;

export type OrgScopedRoutePrefix = (typeof ORG_SCOPED_ROUTE_PREFIXES)[number];
